import { Injectable } from '@angular/core';
import { HostType } from '../models/host-type.enum';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private hostType = HostType.PROD;
  private readonly DATADOG_CLIENT_TOKEN = 'pubd38088732d836d7af1b45fe3c03c7afa';
   DATA_DOG_VERSION = '39284890786';
  DATA_DOG_ENV = '';
  DATA_DOG_TOKEN = '';
  private isDebug = () => {
    return window.location.hostname === 'localhost';
  };

  constructor() {
    this.setHostType();
  }

  get HOST(): string {
    if (this.isDebug()) {
      //return 'http://localhost';		// Change to https://dev.golmn.com/LMN_Admin.API/ if you aren't running the server locally
      return 'https://dev.golmn.com';
    } else {
      if (window.location.host.match(/rt/)) {
        return 'https://rt.golmn.com';
      } else if (window.location.host.match(/qa/)) {
        return 'https://qa.golmn.com';
      } else if (window.location.host.match(/dev2/)) {
        return 'https://dev2.golmn.com';
      } else if (window.location.host.match(/dev/)) {
        return 'https://dev.golmn.com';
      } else {
        return 'https://my.golmn.com';
      }
    }
  }

  get API_BASE(): string {
    if (this.isDebug()) {
      return 'https://dev.golmn.com/LMN_Admin.API/';
      // change to http://localhost:8080/ if you are running the .net8 server locally
    } else {
      if (window.location.host.match(/rt/)) {
        return 'https://rt.golmn.com/LMN_Admin.API/';
      } else if (window.location.host.match(/qa/)) {
        return 'https://qa.golmn.com/LMN_Admin.API/';
      } else if (window.location.host.match(/dev2/)) {
        return 'https://dev2.golmn.com/LMN_Admin.API/';
      } else if (window.location.host.match(/dev/)) {
        return 'https://dev.golmn.com/LMN_Admin.API/';
      } else {
        return 'https://my.golmn.com/LMN_Admin.API/';
      }
    }
  }

  getHostType(): HostType {
    return this.hostType;
  }

  /**
   * HostType is needed as a separate instance
   * Need to define it on init of the service
   */
  private setHostType(): void {
    switch (true) {
      case this.isDebug():
        this.hostType = HostType.LOCAL;
        break;
      case /dev/.test(window.location.host):
      case /dev2/.test(window.location.host):
        this.hostType = HostType.DEV;
        break;
      case /qa/.test(window.location.host):
        this.hostType = HostType.QA;
        this.DATA_DOG_ENV = 'qa';
        this.DATA_DOG_TOKEN = this.DATADOG_CLIENT_TOKEN;
        break;
      case /rt/.test(window.location.host):
        this.hostType = HostType.RT;
        this.DATA_DOG_ENV = 'rt';
        this.DATA_DOG_TOKEN = this.DATADOG_CLIENT_TOKEN;
        break;
      case /my/.test(window.location.host):
        this.hostType = HostType.PROD;
        this.DATA_DOG_ENV = 'production';
        this.DATA_DOG_TOKEN = this.DATADOG_CLIENT_TOKEN;
        break;
      case /groundsguyspro/.test(window.location.host):
        this.hostType = HostType.PROD;
        this.DATA_DOG_ENV = 'production';
        this.DATA_DOG_TOKEN = this.DATADOG_CLIENT_TOKEN;
        break;
      default:
        this.hostType = HostType.PROD;
    }
  }
}
